import React from 'react';

import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

interface DisplayGroupRenderProps {
	displayGroupsProps: DisplayGroupProps;
}

export class DisplayGroupRender extends React.Component<DisplayGroupRenderProps> {
	public render(): JSX.Element {
		const { displayGroups, placeholders, iterableDisplayGroups, iterablePlaceholders } =
			this.props.displayGroupsProps;

		const displayGroupsSort = [...displayGroups]
			.sort((x, y) => x.buildOrder - y.buildOrder)
			.concat(iterableDisplayGroups);

		return (
			<>
				{placeholders
					.concat(iterablePlaceholders)
					.sort((x, y) => x.buildOrder - y.buildOrder)
					.concat(displayGroupsSort)
					.map((x, _index) =>
						React.cloneElement(x.element, {
							...this.props,
							...x.element.props,
						})
					)}
			</>
		);
	}
}
